import React from 'react';
import { cn } from '../utils/cn';
export const Input = React.forwardRef(function Input(
  { label, helperText, error, prefix, suffix, className, id, ...props },
  ref,
) {
  const inputId = id || React.useId();
  const helperId = `${inputId}-helper`;
  const errorId = `${inputId}-error`;
  return (
    <div className="w-full">
      {label && (
        <label htmlFor={inputId} className="mb-1 block text-sm font-medium text-fg-secondary">
          {label}
        </label>
      )}
      <div
        className={cn(
          'flex items-center rounded-md border bg-surface transition-colors duration-150',
          error
            ? 'border-danger-500 focus-within:ring-2 focus-within:ring-danger-500/25'
            : 'border-edge focus-within:border-primary-500 focus-within:ring-2 focus-within:ring-primary-500/25',
          (props.disabled || props.readOnly) && 'bg-surface-secondary opacity-75',
        )}
      >
        {prefix && <span className="pl-3 text-fg-tertiary">{prefix}</span>}
        <input
          ref={ref}
          id={inputId}
          className={cn(
            'w-full bg-transparent px-3 py-2 text-sm text-fg placeholder:text-fg-tertiary',
            'focus:outline-none',
            'disabled:cursor-not-allowed',
            prefix && 'pl-1.5',
            suffix && 'pr-1.5',
            className,
          )}
          aria-invalid={error ? true : undefined}
          aria-describedby={error ? errorId : helperText ? helperId : undefined}
          {...props}
        />
        {suffix && <span className="pr-3 text-fg-tertiary">{suffix}</span>}
      </div>
      {error && (
        <p id={errorId} className="mt-1 text-sm text-danger-600" role="alert">
          {error}
        </p>
      )}
      {!error && helperText && (
        <p id={helperId} className="mt-1 text-sm text-fg-tertiary">
          {helperText}
        </p>
      )}
    </div>
  );
});
